function removeCartFromLocalStorage() {
    localStorage && localStorage.removeItem('stored_cart');
}

export { removeCartFromLocalStorage };
//# sourceMappingURL=remove-cart-from-local-storage.js.map
